import React from 'react';
import { Typography, Card, CardHeader, CardContent, Table, TableHead, TableBody, Stack, Box } from '@mui/material';
import RichTooltip from '../../RichTooltip';
import BreakdownRow from './BreakdownRow';
import BreakdownHeaderRow from './BreakdownHeaderRow';

const BounceBreakdownCard = ({ a, b, showB, text, icon, periodColours, selectedPeriods }) => {
    return (
        <Card sx={{ height: '100%' }}>
            <CardHeader
                avatar={icon}
                title={text}
                slotProps={{
                    title: {
                        variant: 'body1'
                    }
                }}
                sx={{
                    m: 0,
                    p: 1,
                    '& .MuiCardHeader-action': {
                        m: 0
                    },
                    '& .MuiCardHeader-avatar': {
                        mr: 1
                    }
                }}
                action={(
                    <RichTooltip>
                        <Stack spacing={2}>
                            <Box>
                                <Typography variant="body1" sx={{ pb: 0.5 }}>Soft Bounces</Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>Transient issues that may mean emails that weren't delivered straight away</Typography>
                                <Typography variant="body1" sx={{ pb: 0.5, mt: 1 }}>Hard Bounces</Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>Deliverability issues that caused the recipient to be unsubscribed</Typography>
                            </Box>
                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>Accurate to 3 decimal places</Typography>
                        </Stack>
                    </RichTooltip>
                )}
            />
            <CardContent
                sx={{
                    m: 0,
                    p: 0,
                    '&:last-child': {
                        paddingBottom: 0
                    }
                }}
            >
                <Table size="small">
                    <TableHead>
                        <BreakdownHeaderRow
                            showB={showB}
                            aLabel="Period A:"
                            bLabel="Period B:"
                            aDate={selectedPeriods ? selectedPeriods[0] : null}
                        />
                    </TableHead>
                    <TableBody>
                        <BreakdownRow
                            a={a.averageSoftBounceRate * 100}
                            b={b?.averageSoftBounceRate * 100}
                            showB={showB}
                            periodColours={periodColours}
                            text="Soft"
                        />
                        <BreakdownRow
                            a={a.averageHardBounceRate * 100}
                            b={b?.averageHardBounceRate * 100}
                            showB={showB}
                            periodColours={periodColours}
                            text="Hard"
                        />
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
};

export default BounceBreakdownCard;